export default (leadData) => {
    const tags = leadData.tags.reduce((arr,tagObj) => {
        return arr.concat(tagObj.name)
    }, []);

    function getStep (tagsArr) {
        if (tagsArr.includes("Fully Onboarded Claimant")) return window.location.replace(process.env.REACT_APP_CONFIRMATION_URL)
        else if (tagsArr.includes("ID Docs Uploaded")) return 'ADDITIONAL_QUESTIONS_SELECTOR';
        else if (tagsArr.includes("Chase for ID Docs")) return 9;
        else if (tagsArr.includes("Accepted DBA")) return 8;
        else if (tagsArr.includes("Accepted Info Sheet")) return 7;
        else return 6;
    }

    return {
        step: getStep(tags)
    };
};
